import React, { useState, useEffect, useRef, useCallback } from "react";
import { Marker } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-markercluster";
import { useLeaflet } from "react-leaflet";
import MarkerPopup from "./MarkerPopup.jsx";
import api from "../api";

const MemoizedMarker = React.memo(
  ({ data }) => (
    <Marker position={[data.latitude, data.longitude]}>
      <MarkerPopup data={data}></MarkerPopup>
    </Marker>
  ),
  // don't render when ids are the same
  (propOld, propNew) => propOld.data.id === propNew.data.id
);

// Ссылка «Поделиться» из приложения: /station/<id> — карта открывается на этой АЗС.
const SHARED_STATION_PATH = /^\/station\/([^/]+)\/?$/;

const getSharedStationId = () => {
  const match = window.location.pathname.match(SHARED_STATION_PATH);
  return match ? decodeURIComponent(match[1]) : null;
};

export default function Markers() {
  const [data, setData] = useState();
  const [sharedStation, setSharedStation] = useState();
  const { map } = useLeaflet();
  const bounds = useRef();
  const autoPanStarted = useRef(false);
  const sharedMarker = useRef();

  const getStations = useCallback(async (bound) => {
    const stations = await api.gasStation.BB(
      bound._northEast.lng,
      bound._northEast.lat,
      bound._southWest.lng,
      bound._southWest.lat
    );
    if (stations && stations.gasstations) {
      setData(stations.gasstations);
    }
  }, []);

  useEffect(() => {
    map.on("moveend", (e) => {
      const bb = e.target.getBounds();
      const animInProgress = map._panAnim && map._panAnim._inProgress;
      if (
        !autoPanStarted.current &&
        !animInProgress &&
        (!bounds.current || !bounds.current.equals(bb))
      ) {
        bounds.current = bb;
        getStations(bb);
      }
      autoPanStarted.current = false;
    });

    map.on("autopanstart", () => {
      autoPanStarted.current = true;
    });

    // map.on("load") won't work here
    map.whenReady(() => {
      if (!bounds.current) {
        bounds.current = map.getBounds();
        getStations(bounds.current);
      }
    });

    return () => {
      map.off("autopanstart");
      map.off("moveend");
      // whenReady can add "load" listener, better to clean it up
      map.off("load");
    };
  }, [getStations, map]);

  useEffect(() => {
    const id = getSharedStationId();
    if (!id) {
      return;
    }

    api.gasStation.GET(id).then((station) => {
      if (station && station.id) {
        map.setView([station.latitude, station.longitude], 16);
        setSharedStation(station);
      }
    });
  }, [map]);

  // попап открываем, когда маркер уже на карте
  useEffect(() => {
    if (sharedStation && sharedMarker.current) {
      sharedMarker.current.leafletElement.openPopup();
    }
  }, [sharedStation]);

  return (
    <>
      <MarkerClusterGroup>
        {data &&
          data
            // АЗС из ссылки рисуем отдельно, вне кластера, чтобы её попап был открыт
            .filter((d) => !sharedStation || d.id !== sharedStation.id)
            .map((d) => <MemoizedMarker key={d.id} data={d}></MemoizedMarker>)}
      </MarkerClusterGroup>
      {sharedStation && (
        <Marker
          ref={sharedMarker}
          position={[sharedStation.latitude, sharedStation.longitude]}
        >
          <MarkerPopup data={sharedStation}></MarkerPopup>
        </Marker>
      )}
    </>
  );
}
